export const LoadingUserPermissions: string = 'Loading user permissions...';